<template>
    <Tag :color="color">
        {{text}}
    </Tag>
</template>
<script>
    /**
     * 审核状态的显示
     */
    export default {
        name: 'LyShenheStatus',
        props: {
            value: {
                type: [String, Number, Boolean],
                default: ''
            }
        },
        data () {
            return {
                color: 'default'
            }
        },
        computed: {
            text () {
                let str = '待审核'
                this.color = 'default'
                switch (this.value) {
                    case 1:
                        str = '审核通过'
                        this.color = 'success'
                    break;
                    case 2:
                        str = '审核拒绝'
                        this.color = 'error'
                    break;
                    case 3:
                        str = '待转正'
                        this.color = 'warning'
                    break;
                    case 4:
                        str = '已下架'
                        this.color = 'magenta'
                    break;
                    case 5:
                        str = '百度拒绝'
                        this.color = 'error'
                    break;
                    case 6:
                        str = '审核中'
                        this.color = 'warning'
                    break;
                    case 7:
                        str = '总代待审核'
                        this.color = 'warning'
                    break;
                    case 12:
                        str = '待确认'
                        this.color = 'warning'
                    break;
                }
                return str
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ../projectCore/src/components/shenhe-status/src/index.vue